module.exports = new __parcel__URL__("exercise3.97448387.png").toString();